import { useEffect } from "react";
import { stores } from "../stores/rootStore";
import "./devpay.css";
import cash from "./img/cash.svg";
import credit from "./img/credit.svg";
import delivery from "./img/delivery.svg";

export const DeliveryPay = () => {
  useEffect(() => {
    stores.helpUIStore.setTitle("ОПЛАТА И доставка");
    stores.helpUIStore.setHistory(["delivery"]);
  }, []);
  return (
    <div className="del_pay_wrapper">
      {/* <h2>
          Оплата производится безналичным переводом после подтверждения заказа
          менеджером
        </h2> */}
      <div className="del_pay_pay">
        <h2 className="del_pay_title">СПОСОБЫ ОПЛАТЫ</h2>
        <div className="pay_box">
          <div className="pay_item">
            <img src={cash} alt="Наличные" />
            <div>Наличными при самовывозе</div>
          </div>
          <div className="pay_item">
            <img src={credit} alt="Кредитная карта" />
            <div>Безналичным переводом</div>
            <div className="pay_info">
              оплата производится после подтверждения заказа менеджером
            </div>
          </div>
        </div>
      </div>

      <div className="del_pay_delivery">
        <h2 className="del_pay_title">СТОИМОСТЬ ДОСТАВКИ</h2>
        <div className="del_box">
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Октябрьский район 350₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Солнечный 350₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Центр 400₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Университетский 450₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Молодежный 550₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>НовоЛенино 800₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Хрустальный 900₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Патроны 1000₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Листвянка 2600₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Плишкино 800₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Хомутово 1400₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Маркова 700₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Шелехов 1000₽</span>
          </div>
          <div className="del_box_item">
            <img src={delivery} alt="Доставка" />
            <span>Другие районы по согласованию</span>
          </div>
          <div className="del_box_item">
            <span>*Доставки в период времени 20:00-10:30 +200₽</span>
          </div>
          <div className="del_box_item">
            <span>*Обрабатываем заказы 10:00-20:00</span>
          </div>
        </div>
      </div>
    </div>
  );
};
